import { utcDateString } from './geohashUtil';

export const SEED_VIEW_DEDUP = [
  { thread_id: 1, user_id: 1001, bucket_date: utcDateString() },
  { thread_id: 2, user_id: 1002, bucket_date: utcDateString() },
];
